import React, { useState, useEffect } from 'react';
import './css/contact.css';
import { useLanguage } from '../contexts/LanguageContext';

const ContactSection = () => {
  const { t, language } = useLanguage();
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    email: '',
    phone: '',
    message: ''
  });
  const [contactDetails, setContactDetails] = useState([]);

  useEffect(() => {
    loadContactDetails();
  }, []);

  const loadContactDetails = async () => {
    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL || 'https://server.acpca.net/api'}/contact-details`);
      const data = await response.json();
      if (data.success) {
        setContactDetails(data.data);
      }
    } catch (error) {
      console.error('Error loading contact details:', error);
    }
  };

  const getContactDetail = (type) => {
    const detail = contactDetails.find(d => d.contact_type === type);
    if (!detail) return null;
    return {
      value: language === 'ar' ? (detail.value_ar || detail.value_en) : (detail.value_en || detail.value_ar),
      url: detail.url
    };
  };

  const emailDetail = getContactDetail('email');
  const phoneDetail = getContactDetail('phone');
  const addressDetail = getContactDetail('address');

  const locations = [
    {
      id: 1,
      city: language === 'ar' ? t('contact.location.city') : 'Makkah',
      address: addressDetail?.value || (language === 'ar' ? t('contact.location.address') : 'Makkah, Saudi Arabia'),
      email: emailDetail?.value || (language === 'ar' ? t('contact.location.email') : 'info@morasalat.com'),
      phone: phoneDetail?.value || (language === 'ar' ? t('contact.location.phone') : '+96600000000'),
      emailUrl: emailDetail?.url,
      phoneUrl: phoneDetail?.url
    }
  ];

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = () => {
    console.log('Form submitted:', formData);
    alert(t('contact.successMessage'));
  };

  return (
    <section className="contact-section" dir="rtl">
      <div className="contact-container">
        <div className="contact-content">
          
          {/* Left Side */}
          <div className="contact-info">
            <div className="info-header">
              <div className="info-tag">
                <span className="tag-line"></span>
                <span className="tag-text">{t('contact.tag')}</span>
                <span className="tag-line"></span>
              </div>

              <h2 className="info-title">
                {t('contact.title')}
              </h2>

              <p className="info-description">
                {t('contact.description')}
              </p>
            </div>

            {/* Locations */}
            <div className="locations-grid">
              {locations.map((location) => (
                <div key={location.id} className="location-card">
                  <h3 className="location-city">{location.city}</h3>
                  <p className="location-address">{location.address}</p>
                  {location.emailUrl ? (
                    <a href={location.emailUrl} className="location-email" style={{ color: 'inherit', textDecoration: 'none' }}>
                      {location.email}
                    </a>
                  ) : (
                    <p className="location-email">{location.email}</p>
                  )}
                  {location.phoneUrl ? (
                    <a href={location.phoneUrl} className="location-phone" style={{ color: 'inherit', textDecoration: 'none' }}>
                      {location.phone}
                    </a>
                  ) : (
                    <p className="location-phone">{location.phone}</p>
                  )}
                </div>
              ))}
            </div>
          </div>

          {/* Right Side */}
          <div className="contact-form-wrapper">
            <div className="form-container">
              <h3 className="form-title">{t('contact.formTitle')}</h3>
              <p className="form-description">
                {t('contact.formDescription')}
              </p>

              <div className="contact-form">
                <div className="form-row">
                  <div className="form-group">
                    <input
                      type="text"
                      name="firstName"
                      value={formData.firstName}
                      onChange={handleChange}
                      placeholder={t('contact.firstName')}
                      className="form-input"
                    />
                  </div>
                  <div className="form-group">
                    <input
                      type="text"
                      name="lastName"
                      value={formData.lastName}
                      onChange={handleChange}
                      placeholder={t('contact.lastName')}
                      className="form-input"
                    />
                  </div>
                </div>

                <div className="form-group">
                  <input
                    type="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    placeholder={t('contact.email')}
                    className="form-input"
                  />
                </div>

                <div className="form-group">
                  <input
                    type="tel"
                    name="phone"
                    value={formData.phone}
                    onChange={handleChange}
                    placeholder={t('contact.phone')}
                    className="form-input"
                  />
                </div>

                <div className="form-group">
                  <textarea
                    name="message"
                    value={formData.message}
                    onChange={handleChange}
                    placeholder={t('contact.message')}
                    className="form-textarea"
                    rows="5"
                  ></textarea>
                </div>

                <button onClick={handleSubmit} className="submit-button">
                  {t('contact.submit')}
                </button>
              </div>
            </div>
          </div>

        </div>
      </div>
    </section>
  );
};

export default ContactSection;
